var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3012 9.86736L7.13966 0.521116C6.95954 0.19478 6.64329 0 6.29359 0C5.9439 0 5.62765 0.19478 5.44811 0.520478L0.286014 9.86736C0.102953 10.1988 0.0982594 10.6133 0.273106 10.9498C0.447367 11.2864 0.776525 11.4952 1.13209 11.4952H11.4557C11.8107 11.4952 12.1404 11.2864 12.3147 10.9498C12.4895 10.6133 12.4842 10.1988 12.3012 9.86736ZM6.88038 9.57934H5.70691V8.30209H6.88038V9.57934ZM5.70691 7.02485H6.88038V3.83173H5.70691V7.02485Z",
    fill: "#DA4167"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconRed);
export default __webpack_public_path__ + "static/media/alertIconRed.58bb157f.svg";
export { ForwardRef as ReactComponent };